var map = {
	"./block-banner/block-banner.js": "../modules/block-banner/block-banner.js",
	"./block-cg/block-cg.js": "../modules/block-cg/block-cg.js",
	"./block-kq/block-kq.js": "../modules/block-kq/block-kq.js",
	"./block-ph/block-ph.js": "../modules/block-ph/block-ph.js",
	"./block-res/block-res.js": "../modules/block-res/block-res.js",
	"./block-search/block-search.js": "../modules/block-search/block-search.js",
	"./block-service/block-service.js": "../modules/block-service/block-service.js",
	"./block-slide/block-slide.js": "../modules/block-slide/block-slide.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../modules sync recursive ^\\.\\/.*\\.js$";